import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {  Tooltip } from '@mui/material';
import { format } from 'date-fns';
import { DateFormats } from 'shared';
import { Link } from 'react-router-dom';

import { useAuditLogs } from "../../hooks/useAuditLogs";
import { Card } from "../../../common/Atoms/Card";
import { LoadingOverlay } from '../Molecules/LoadingOverlay';
import { Heading } from '../../../common/Atoms/Typography/Heading';
import { MultiButtonCardHeader } from '../../../common/Atoms/MultiButtonCardHeader';
import { Paragraph } from '../../../common/Atoms/Typography/Paragraph';

import { ChangeDetail } from './ChangeDetail';

export function AuditLogRoot() {
  const { data: auditLogs, isFetching, isLoading, entityType, entityId } = useAuditLogs();
  const isFiltered = !!(entityType || entityId);

  const filterLabel = entityType && entityId
    ? `${entityType} ${entityId}`
    : entityType || entityId;

  const rows = auditLogs || [];

  return (
    <Card>
      <MultiButtonCardHeader
        title={ `Audit Logs` }
        description={ `View recent policy and setting changes. Last 100 results are shown.` }
        noDivider
      />
      { isFiltered && (
        <div className={ `px-6 py-2 bg-gray-50 border-b border-gray-200 flex items-center justify-between` }>
          <Paragraph variant={ `help` }>
            { `Filtered to ${filterLabel}` }
          </Paragraph>
          <Link to={ `.` }
            className={ `text-sm text-blue-600 hover:underline` }>
            { `Clear filter` }
          </Link>
        </div>
      ) }
      <LoadingOverlay
        loading={ isFetching || isLoading }
      >
        <TableContainer>
          <Table sx={ { minWidth: 650 } }
            size={ `small` }
            aria-label={ `audit log table` }>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Heading
                    variant={ `secondary` }
                  >
                    { `Date Changed` }
                  </Heading>
                </TableCell>
                <TableCell align={ `right` }>
                  <Heading
                    variant={ `secondary` }
                  >{ `Log Type` }
                  </Heading>
                </TableCell>
                <Tooltip title={ `Which user made this change` }>
                  <TableCell align={ `right` }>
                    <Heading
                      variant={ `secondary` }
                    >{ `User` }
                    </Heading>
                  </TableCell>
                </Tooltip>
                <TableCell align={ `right` }>
                  <Heading
                    variant={ `secondary` }
                  >
                    { `Message` }
                  </Heading>
                </TableCell>
                <TableCell align={ `right` }>
                  <Heading
                    variant={ `secondary` }
                  >

                    { `Change Detail` }
                  </Heading>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { rows.map(row => (
                <TableRow
                  key={ row.id }
                  sx={ { '&:last-child td, &:last-child th': { border: 0 } } }
                >
                  <TableCell component={ `th` }
                    scope={ `row` }>
                    { format(new Date(row.timestamp), DateFormats.UI_SHORT_TIME) }
                  </TableCell>
                  <TableCell align={ `right` }>
                    <Tooltip title={ row.id }>
                      <span className={ `flex flex-col` }>
                        {
                          row.auditLogEntryType
                        }
                        <Paragraph
                          variant={ `help` }
                          as={ `span` }
                        >
                          {
                            row.title ? `(${row.title})` : ``
                          }
                        </Paragraph>
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell align={ `right` }>
                    {
                      row.wasAdminOverride ? `Paidnice Admin` : row.userEmail
                    }
                  </TableCell>
                  <TableCell align={ `right` }>{ row.userMessage }</TableCell>
                  <TableCell align={ `right` }>
                    <ChangeDetail
                      entry={ row }
                    />
                  </TableCell>
                </TableRow>
              )) }
            </TableBody>
          </Table>
        </TableContainer>
      </LoadingOverlay>
    </Card>
  );
}

